import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from './../../../utils/styles'
import styles from './Labelled.scss'
import Label from './../Label'
import { ErrorText } from './../../index'

export default function Labelled({ id, label, error, helpText, children, labelHidden, ...rest }) {
  const className = classNames(labelHidden && styles.hidden, styles.Field)

  const helpTextMarkup = helpText ? (
    <div className={styles.HelpText} id={helpTextID(id)}>
      {helpText}
    </div>
  ) : null

  const errorMarkup = error &&
    typeof error === 'string' && (
      <ErrorText id={errorID(id)} transKey={error}>
        {error}
      </ErrorText>
    )

  const labelMarkup = label ? (
    <div className={styles.LabelWrapper}>
      <Label id={id} {...rest} hidden={false}>
        {label}
      </Label>
    </div>
  ) : null

  return (
    <div className={className}>
      {labelMarkup}
      {children}
      {errorMarkup}
      {helpTextMarkup}
    </div>
  )
}

export function errorID(id) {
  return `${id}Error`
}

export function helpTextID(id) {
  return `${id}HelpText`
}

Labelled.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.any,
  helpText: PropTypes.any,
  children: PropTypes.any,
  labelHidden: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Form/Labelled/index.js